'use client';

import Link from 'next/link';
import Image from 'next/image';

import Badge from '@/components/badge/Badge';
import { useCampaign } from '@/app/CampaignContext';
import { useModal } from '@/components/modal/ModalProvider';
import { getLowestAmountAvailable } from '@/utils/helpers';
import { findBiggestDiscount } from '@/utils/discounts';

export default function ProductCard({ images, ...rest }) {
  const { title, url, collections_tag, variants } = rest;
  const campaignCtx = useCampaign();
  const { showPriceDetails } = useModal();
  const discountMsg = findBiggestDiscount(variants, campaignCtx);

  function handlePriceModalClick(e, title) {
    e.preventDefault();
    showPriceDetails(
      `product-card-${title}`,
      null,
      campaignCtx?.pricing_details
    );
  }

  return (
    <li className="relative flex h-full max-w-[280px] flex-col justify-between bg-white lg:max-w-full">
      <Link href={url} prefetch={false}>
        <span
          className={`badge-text-s lg:badge-text-r absolute right-0 inline-block content-center`}
        >
          {discountMsg !== '' && (
            <div
              className={`bg-[${campaignCtx.discount_tag.background_color_picker}] text-[${campaignCtx.discount_tag.text_color_picker}] badge-text-s lg:badge-text-r px-2 py-1`}
            >
              {discountMsg}
            </div>
          )}
        </span>
        <Image
          src={images.desktop.url}
          alt={images.desktop.title}
          width="327"
          height="184"
          sizes="(min-width: 1024px) 327px, (min-width: 640px) 280px, 280px"
          className="mb-2 w-95 max-[640px]:hidden"
        />
        <Image
          src={images.mobile.url}
          alt={images.mobile.title}
          width="200"
          height="200"
          sizes="200px"
          className="mb-2 min-[641px]:hidden"
        />
      </Link>
      <Link href={url} prefetch={false}>
        <h3 className="h6 sm:h5 mb-2">{title}</h3>
      </Link>
      {collections_tag &&
        collections_tag.show_tag &&
        collections_tag.tag_text && (
          <Badge
            text={collections_tag.tag_text}
            className="badge-text-r mb-2 px-[6px]! py-[1px]!"
            textColor={collections_tag.text_color_picker}
            backgroundColor={collections_tag.background_color_picker}
          />
        )}
      <ProductPrice variants={variants} />
      <p
        className="price-r-label text-grey-text cursor-pointer underline"
        onClick={(e) => handlePriceModalClick(e, title)}
      >
        Price details
      </p>
    </li>
  );
}

const ProductPrice = ({ variants }) => {
  const lowestPrice = getLowestAmountAvailable(variants, 'price', 'amount');
  const compareAtLowestPrice = getLowestAmountAvailable(
    variants,
    'compareAtPrice',
    'amount'
  );

  return (
    <div>
      <span className="price-r-label mr-1">From </span>
      <span className="sr-only">Sale price is</span>
      <span className="price-r mr-1 no-underline">
        ${Math.trunc(Number(lowestPrice))}{' '}
      </span>
      <span className="sr-only">Original price is</span>
      <s className="price-r-crossed">
        ${Math.trunc(Number(compareAtLowestPrice))}
      </s>
    </div>
  );
};
